<template>
  <div class="certificate">
    <div class="main">
      <z-steps :step="3" style="background:#fafafa;"></z-steps>
      <div class="certificate-details-msg">
        <div class="title">线下汇款</div>
        <div class="text-msg">
          <div class="msgDetail">
            <p>
              支付内容：
              <span>{{ orderDetail.paymentStage }}</span>
              <span
                v-if="
                  orderDetail.paymentStagePercent &&
                    orderDetail.paymentStagePercent > 0
                "
                >（{{ orderDetail.paymentStagePercent }}%）</span
              >
            </p>
            <p class="orderPrice">
              应付：
              <span class="price red-font">{{
                orderDetail.amountDisplay | currency("¥", "2")
              }}</span>
            </p>
            <p class="orderNum">
              订单号：
              <span>{{ orderDetail.code }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="certificate-detail-input">
        <div class="title">转账信息</div>
        <Row type="flex" justify="start" class="flex-row">
          <Col span="12">
            <div class="zhulogic">住逻辑官方账号</div>
            <p>
              账号 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span>{{ bank.bankAccount }}</span>
            </p>
            <p>
              开户行名称 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span>{{ bank.bankName }}</span>
            </p>
            <p>
              开户人
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span>{{ bank.bankUserName }}</span>
            </p>
          </Col>
          <Col span="12">
            <div class="zhulogic">甲方付款账号</div>
            <Form
              ref="formInline"
              :model="formValidate"
              :rules="ruleValidate"
              :label-width="70"
              label-position="left"
            >
              <FormItem label="户名：" style="width:400px;" prop="name">
                <Input
                  v-model="formValidate.name"
                  :maxlength="50"
                  placeholder="请输入户名"
                ></Input>
              </FormItem>
              <FormItem
                style="width:500px;margin-top: -22px; margin-left: -10px;"
                prop="name"
              >
                <span class="chioceTitle-msg">
                  <i class="iconfont icon-jinggao"></i>
                  开票抬头为您的汇款方抬头，请使用您需要开票的对公账号支付。
                </span>
              </FormItem>
            </Form>
          </Col>
        </Row>
        <div class="bottom-msg">
          <p>
            汇款识别码 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>{{ orderDetail.remitCode }}</span>
          </p>
          <p class="text">
            请将汇款识别码填写至【
            <span>汇款用途</span>】【 <span>附言</span>】【
            <span>备注</span>】等栏目内
          </p>
        </div>
      </div>

      <Row
        class="botom_btn"
        type="flex"
        :gutter="30"
        justify="center"
        align="middle"
      >
        <Col span="5">
          <Button
            :data-clipboard-text="
              `收款账号：${bank.bankAccount}\n开户行名称：${bank.bankName}\n收款户名：${bank.bankUserName}\n汇款识别码：${orderDetail.remitCode}\n请将汇款识别码填写至【汇款用途】【附言】【备注】等栏目内\n付款账户：${formValidate.name}`
            "
            class="copy"
            long
            :loading="loading"
            @click="submitCopy"
            >复制全部内容</Button
          >
        </Col>
        <Col span="5">
          <Button
            class="red-btn"
            long
            :loading="loading"
            @click="submit"
            type="primary"
            >{{ loading ? "提交中..." : "已转账，提交收款请求" }}</Button
          >
        </Col>
      </Row>
    </div>
    <div style="height:70px;"></div>
  </div>
</template>

<script>
import api from "../../../../api";
import payTop from "./payTop.vue";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      formValidate: {
        name: ""
      },
      orderDetail: "",
      bank: "",
      loading: false,
      upload: {
        certificateFile: undefined
      },
      title: "上传支付凭证",
      imgBaseUrl: api.common.imgBaseUrl,
      progress: 0,
      ruleValidate: {
        name: [
          {
            required: true,
            message: "请输入户名",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    getPayInfo() {
      api.pay.payMentInfo(this.$route.params.id).then(res => {
        this.orderDetail = res;
        if (this.orderDetail.certificateFile) {
          this.upload.certificateFile = this.orderDetail.certificateFile;
        }
      });
    },
    getBankAccount() {
      api.pay.payBank(this.$route.params.id).then(res => {
        this.bank = res;
      });
    },
    submitCopy() {
      let clipboard = new Clipboard(".copy");
      setTimeout(() => {
        this.$Message.success("成功复制到剪切板");
      }, 500);
    },
    submit() {
      if (!this.formValidate.name) {
        this.$Message.warning("请填写户名");
        return;
      }
      this.loading = true;
      api.pay
        .uploadCertificate(this.$route.params.id, {
          accountName: this.formValidate.name
        })
        .then(res => {
          this.loading = false;
          this.$router.push({
            name: "payOfflineSuccess",
            params: { id: this.$route.params.id, type: "orderStage" },
            query: { paymentId: res }
          });
        })
        .catch(err => {
          this.loading = false;
        });
    },
    getCopyName() {
      api.orders.apply_name(this.$route.params.id).then(res => {
        this.formValidate.name = res;
      });
    }
  },
  components: {
    payTop
  },
  created() {
    this.type = this.$route.params.type;
    this.getPayInfo();
    this.getBankAccount();
    this.getCopyName();
  }
};
</script>
<style scoped lang="scss">
.certificate {
  padding-top: 46px;
}
.certificate .main {
  width: 1200px;
  margin: 0px auto;
  margin-bottom: 0;
}
.submit-btn button {
  width: 144px;
  height: 40px;
  float: right;
  margin-top: 26px;
}
.botom_btn {
  margin-top: 60px;
}
</style>

<style lang="scss">
.main-panel {
  margin-top: -10px;
  .zSteps-common .col-span {
    background: #313131;
  }
  .zSteps-line .line {
    width: 0px !important;
  }
}

.certificate-details-msg {
  background: #fff;
  margin-top: 20px;
  .title {
    font-weight: 500;
    font-size: 18px;
    padding: 20px;
    border-bottom: 1px solid #e7e7e7;
  }
  .msgDetail {
    padding: 20px 30px;
    p {
      font-size: 16px;
      margin-top: 5px;
      color: #707070;
      span {
        color: #313131;
      }
      span.price {
        color: #eb5757;
        font-size: 16px;
      }
    }
  }
}
.certificate-detail-input {
  margin-top: 30px;
  min-height: 400px;
  background: url("../../../../images/flow-bg.png"), no-repeat;
  width: 100%;
  height: 40%;
  background-size: 100% 100%;
  .title {
    width: 100%;
    height: 60px;
    text-align: center;
    line-height: 60px;
    font-weight: 500;
    font-size: 18px;
    color: #313131;
  }
  .flex-row {
    padding: 40px;
    padding-bottom: 60px;
    .ivu-col {
      text-align: left;
    }
    .zhulogic {
      font-weight: 500;
      font-size: 16px;
      margin-bottom: 35px;
    }
    p {
      font-size: 14px;
      color: #707070;
      margin: 7px;
      span {
        color: #313131;
      }
    }
    .bottom-msg {
      margin-top: 200px;
    }
  }
  .bottom-msg {
    padding: 0 40px;
    p {
      font-size: 14px;
      color: #707070;
      margin: 7px;
      span {
        color: #313131;
      }
    }
    .text {
      span {
        color: #eb5757;
      }
    }
  }
  .ivu-form .ivu-form-item-label {
    font-size: 14px;
    color: #707070 !important;
    margin-top: -5px;
    font-weight: 400 !important;
  }
  .chioceTitle-msg {
    color: #eb5757;
    display: inline-block;
    margin-left: 10px;
    vertical-align: middle;
    font-size: 12px;
  }
  .chioceTitle-msg i {
    vertical-align: middle;
    font-size: 20px;
  }
}
</style>
